/**
 * Espande o riduce la mappa nella versione mobile
 */
function expandMap(index) {

    $('.map-wrapper > .map').toggleClass("expand-visual-map");

    /**
     * Richiama la funzione per inizializzare la mappa
     * questa funzione si trova nelle singole pagine
     */
    //if( isFunction(initCurrentMap) ) {
    //    initCurrentMap(index);
    //}
}

function reduceMap() {
    $('.map-wrapper > .map').removeClass("expand-visual-map");
}

/**
 * Inizialize scroll to
 *
 * @param element
 */
function inizializeScrollTo(element, duration) {
    $(element).velocity("scroll", { duration: duration });
}

/**
 * Inizialize scroll to with offset
 *
 * @param element
 * @param offset
 */
function inizializeScrollToWithOffset(element, duration, offset) {
    $(element).velocity("scroll", { duration: duration, offset: offset });
}

function scrollToUp() {
    $('html').velocity("scroll", { duration: 750 });
}

// if ($('#main-menu .js-new-badge').length) {
//
//     $('#main-menu .js-new-badge').each(function (k, v) {
//         var parentMenuVoice = $($(v).parentsUntil('.dropdown').parent().find('.dropdown-toggle')[0]);
//         parentMenuVoice.html('<span class="new-badge js-new-badge"><span class="badge-content">NEW</span></span>'+parentMenuVoice.html())
//     });
// }

if ($('#main-menu .js-new-badge').length) {
    $('#main-menu .js-new-badge').each(function (k, v) {
        var parentMenuVoice = $($(v).parentsUntil('.dropdown').parent().find('.dropdown-toggle')[0]);
        parentMenuVoice.append('<span class="new-badge js-new-badge"><span class="badge-content">NEW</span></span>');
    });
}
